import { Card } from '@material-ui/core';
import styled from 'styled-components';
import color from '../../constants/color';

export const Container = styled(Card)`
  display: flex;
  margin: 16px;
  flex-direction: column;
  background-color: ${color.white};
  border-radius: 6px;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 60px;
  align-items: center;
  padding: 0px 30px 0px 30px;
  justify-content: space-between;
`;
export const Title = styled.div`
  font-size: 1.25em;
  font-family: inter;
`;
export const Circle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 30px;
  border: 1px solid #6587FF;
`;
export const HeaderTable = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 45px;
  background-color: ${color.white};
  align-items: center;
  margin: 18px 30px 0px 30px;
  padding: 0px 0px 0px 10px;
  border-bottom: 1px solid #6587FF;

  div {
    font-size: 12px;
    font-weight: 400;
    font-family: Inter;
    color: ${color.blue};
  }
`;
export const Name = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  text-transform: uppercase;
`;
export const Sigla = styled.div`
  display: flex;
  width: 10%;
`;
export const User = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 15%;
`;
export const Regional: any = styled.div`
  display: flex;
  width: 10%;
`;
export const Status = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 10%;
`;
export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 10%;
`;
export const ListContainer: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  min-height: 60px;
  align-items: center;
  margin: 0px 30px 0px 30px;
  padding: 4px 0px 4px 10px;

  @media only screen and (max-width: 700px) {

  }

  div {
    font-size: 14px;
    font-family: Inter;
  }
`;
export const ContainerPagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content:  space-between;
  margin-top: 30px;
  margin-left: 30px;
  margin-bottom: 20px;
  margin-right: 30px;

  select {
    width:  50px;
    height: 30px;
    border-radius: 4px;
    border: none;
    border: 1px solid #cecece;
    outline:none;
    padding-left: 4px;
    margin-left: 20px;
  }
`;
export const Arrow = styled.div`
  display: flex;
  width: 25px;
  justify-content: center;
  align-items: center;
  height: 25px;

  margin: 0px 4px 0px 4px;
  background-color: ${color.grey6};
  border-radius: 30px;
`;
export const ContainerPages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  border-radius: 2px;
  background-color: ${color.grey6};
  margin: 0px 10px 0px 10px;
`;
export const Page = styled.div`
  display: flex;
  width: 14px;
  justify-content: center;
  align-items: center;
  height: 14px;
  font-size: 12px;
  border-radius: 4px;
  margin: 0px 4px 0px 4px;
  padding: 2px 0px 0px 0px;
`;
export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const SizedBox: any = styled.div`
  margin-top: 32px;
`;
export const Img: any = styled.img`
  height: 16px;
`;
